// Generated by scripts/sync-catalog-sitemap.mjs - do not edit by hand.
// Re-run: pnpm sync:catalog-sitemap
export const providersSlugMap = {
    "1x2gaming": "1X2gaming",
    "4theplayer": "4ThePlayer",
    "adlunam": "AdLunam",
    "avatarux": "AvatarUX",
    "aviator": "Aviator",
    "aviatrix": "Aviatrix",
    "bang-bang-games": "Bang Bang Games",
    "betgames": "BetGames",
    "betnow": "BetNow",
    "bgaming": "BGaming",
    "bigpot-gaming": "Bigpot Gaming",
    "blueprint-gaming": "Blueprint Gaming",
    "boominggames": "BoomingGames",
    "bulletproof-games": "Bulletproof Games",
    "coinraces": "Coinraces",
    "cq9slot": "Cq9slot",
    "creedroomz": "Creedroomz",
    "edgelabs": "Edgelabs",
    "elagames": "Elagames",
    "electric-elephant": "Electric Elephant",
    "emeraldgate": "Emeraldgate",
    "endorphina": "Endorphina",
    "evoplay": "Evoplay",
    "exco": "Exco",
    "expanse-studios": "Expanse Studios",
    "ezugi": "Ezugi",
    "fantasma": "Fantasma",
    "fatpanda": "Fatpanda",
    "fbastards": "Fbastards",
    "fbmds": "FBMDS",
    "flatdog": "Flatdog",
    "fomo-originals": "Fomo Originals",
    "four-leaf-gaming": "Four Leaf Gaming",
    "funkygames": "Funkygames",
    "galaxsys": "Galaxsys",
    "gameart": "GameArt",
    "gametech": "GameTech",
    "gamingcorps": "GamingCorps",
    "habanero": "Habanero",
    "hacksaw-gaming": "Hacksaw Gaming",
    "hissho-dragon": "Hissho Dragon",
    "holdyourhat": "Holdyourhat",
    "hot-rise-games": "Hot Rise Games",
    "iconic21": "Iconic21",
    "irondog": "IronDog",
    "jacks": "Jacks",
    "jili-games": "Jili Games",
    "justslots": "Justslots",
    "konquer": "Konquer",
    "libertyspins": "Libertyspins",
    "manna-play": "Manna Play",
    "mascotgaming": "Mascotgaming",
    "max-win-gaming": "Max Win Gaming",
    "maxxilabs": "Maxxilabs",
    "mg-live": "MG Live",
    "microgaming-live": "MicroGaming Live",
    "million-games": "Million Games",
    "novomatic": "Novomatic",
    "onetouch": "Onetouch",
    "penguinking": "Penguinking",
    "peter-and-sons": "Peter & Sons",
    "pgsoft": "PGSoft",
    "play-beyond-games": "Play Beyond Games",
    "play-n-go": "Play n GO",
    "playace": "Playace",
    "playgenx": "Playgenx",
    "playnetic": "Playnetic",
    "playngopremium": "Playngopremium",
    "playson": "Playson",
    "playtech": "Playtech",
    "playtech-live": "Playtech Live",
    "playzia": "Playzia",
    "popiplay": "Popiplay",
    "pragmatic-play": "Pragmatic Play",
    "pragmatic-play-live": "Pragmatic Play Live",
    "print-studios": "Print Studios",
    "prospectgaming": "ProspectGaming",
    "quickspin": "Quickspin",
    "ready-play-gaming": "Ready Play Gaming",
    "reelplay": "ReelPlay",
    "reflex-gaming": "Reflex Gaming",
    "relax-gaming": "Relax Gaming",
    "rogue-gaming": "Rogue Gaming",
    "rubyplay": "Rubyplay",
    "sgaming": "SGaming",
    "shadylady": "Shadylady",
    "skillex": "Skillex",
    "skywind": "Skywind",
    "skywind-live": "Skywind Live",
    "slot-factory": "Slot Factory",
    "slotmill": "Slotmill",
    "slotopia": "Slotopia",
    "solvited": "Solvited",
    "speedytomatoes": "Speedytomatoes",
    "storm-gaming": "Storm Gaming",
    "sweepnow": "Sweepnow",
    "taparoo": "Taparoo",
    "thunderkick": "Thunderkick",
    "tomhorn": "TomHorn",
    "topspin": "Topspin",
    "trigger": "Trigger",
    "turbogames": "Turbogames",
    "twainsport": "TwainSport",
    "updown": "Updown",
    "uroc": "Uroc",
    "wazdan": "Wazdan",
    "wickedgames": "Wickedgames",
    "winfast": "Winfast",
    "woahlabs": "Woahlabs",
    "yggdrasil-gaming": "Yggdrasil Gaming",
};
